module.exports = __webpack_public_path__ + "static/media/kaisai.bd489c61.jpg";